import { lazy } from "react";

const routes = [
    {
        path: "/",
        isExact: true,
        component: lazy(() => import("./ChatOpen"))
    }
]
export default routes;